import React from 'react';
import styles from './EventCard.module.css';
import { useSelector } from 'react-redux';
import { formatDateNormal, formatDateRange, getLocale, isMoreThanHours } from '../../../helpers/dates';
import { useTranslation } from 'react-i18next';
import Image from '../../Image/Image';

const EventCard = ({ event, onClick }) => {
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);
  const { t } = useTranslation();

  return (
    <div className='row mt-1' onClick={() => onClick()}>
      <div className={`col `}>
        <div className={styles.container}>
          <div className='row m-0' style={{ minHeight: '100px' }}>
            <div className='col-auto my-auto pl-2'>
              <div className='position-relative'>
                <Image
                  className={styles.eventImage}
                  src={event.bannerImage}
                  alt='product'
                  size='MEDIUM'
                  progressive={true}
                  width={80}
                />
              </div>
            </div>

            <div className={`col text-truncate my-auto px-2`}>
              <div className='sentences-capitalize'>
                {isMoreThanHours(event.startDate, event.endDate, 24) ? (
                  formatDateRange(event.startDate, event.endDate, locale)
                ) : (
                  formatDateNormal(event.startDate, locale)
                )}
              </div>

              <div className='fw-semibold font-medium text-truncate'>{event?.name}</div>
            </div>
            {event.associatedProducts === false && (
              <div className={styles.comingSoon}>{t('comingSoon')}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
